
import Vue from "vue";
import Spinner from "@/components/common/spinner.vue";
import MaterialIcons from "@/components/common/material-icons.vue";

export default Vue.extend({
  name: "v-button",
  components: { Spinner, MaterialIcons },
  props: {
    isBold: { type: Boolean, default: false },
    uiType: {
      type: String,
      required: true,
      validator: (value: string) => {
        return [
          "",
          "primary",
          "outlined",
          "text",
          "danger",
          "danger2",
          "dashed",
          "outlined2",
          "outlined-white",
          "icon-only",
          "apply",
          "outlined-gray",
        ].includes(value);
      },
    },
    title: { type: String, required: false },
    iconName: { type: String, required: false },
    iconSize: { type: Number, default: 24, required: false },
    iconNameRight: { type: String, required: false },
    status: {
      type: String,
      default: "normal",
      validator: (value: string) => {
        return ["normal", "loading", "success", "error"].includes(value);
      },
    },
    mainColor: { type: String, required: false },
    imgSrc: {
      type: String,
      required: false,
    },
    imgSrcSize: String,
    imgSrcRight: {
      type: String,
      required: false,
    },
    imgSrcRightSize: String,
  },
  computed: {
    getImgSrc(): undefined | string {
      return this.imgSrc;
    },
    getImgSrcRight(): undefined | string {
      return this.imgSrcRight;
    },
    name(): string | undefined {
      switch (this.status) {
        case "loading":
          return "";
        case "success":
          return "done";
        case "error":
          return "error";
        default:
          return this.iconName;
      }
    },
  },
});
